import React, { useRef, useEffect, useState } from 'react';
import { Button, Container, Stack, Typography, useTheme } from '@mui/material';
import { Wifi, WifiOff } from '@mui/icons-material';
import styled from '@emotion/styled';
import { grey } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

const Offline: React.FC = () => {
	console.log('rendering /offline');
	const theme = useTheme();
	const navigate = useNavigate();
	const [offline, setOffline] = useState<boolean>(true);
	const onlineTimeout = useRef<NodeJS.Timeout>(null);

	const handleOnline = () => {
		setOffline(false);

		// @ts-ignore
		onlineTimeout.current = setTimeout(() => {
			navigate('/serve');
		}, 3000);
	};

	useEffect(() => {
		// instantly go to serve page if online handler is called
		window.addEventListener('online', handleOnline);

		return () => {
			window.removeEventListener('online', handleOnline);
		};
	}, []);

	return (
		<Styles>
			<Stack
				sx={{ height: '100%', width: '100%' }}
				alignItems="center"
				justifyContent="center"
			>
				<Container maxWidth="md">
					<Stack spacing={4} alignItems="center" justifyContent="center">
						<div className="icon-wrapper">
							{offline ? <WifiOff fontSize="large" /> : <Wifi fontSize="large" />}
						</div>
						<Stack spacing={2} alignItems="center" justifyContent="center">
							<Typography align="center" variant="h1">
								{offline ? 'Offline' : 'Connected'}
							</Typography>
							<Typography
								align="center"
								sx={{ maxWidth: '34ch', color: theme.palette.text.secondary }}
							>
								{offline
									? 'You no longer have an internet connection, please connect to a network in order to manage this deployment.'
									: 'We found an internet connection, redirecting you now...'}
							</Typography>
						</Stack>
						<div>
							<Button component={RouterLink} to="/serve" variant="contained">
								Back to Experience
							</Button>
						</div>
					</Stack>
				</Container>
			</Stack>
		</Styles>
	);
};

const Styles = styled.div`
	height: 100%;

	.icon-wrapper {
		height: 100px;
		width: 100px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background: ${grey['800']};
	}
`;

export default Offline;
